import useAppTranslation from "@hooks/language/useAppTranslation";
import { Flex } from "@mantine/core";
import SEO from "@modules/seo/SEO";
import ReviewHeadline from "../components/ReviewHeadline";
import ReviewHero from "../components/ReviewHero";
import ReviewList from "../components/ReviewList";

const Reviews = () => {
  const { t } = useAppTranslation("pages.reviews");

  return (
    <>
      <SEO description={t("seo.description")} title={t("seo.title")} />
      <ReviewHero />

      <Flex className="relative mb-12 w-full flex-col md:flex" gap={10}>
        <ReviewHeadline />
      </Flex>

      <ReviewList />
    </>
  );
};

export default Reviews;
